define([
    "jquery",
    "underscore",
    "marionette",
    "e_calendar"
], function($, _, Marionette, eCalendar) {
    return Marionette.View.extend({
        el: '#header_layout',

        ui:{
            'menuTabs': '.ct_mainnav > ul li',
            'closePopover': '.close_popover',
            'popover': '#e_calendar_toggle',
            'popoverContent': '#e_calendar_popover_content',
            'popoverTitle': '#e_calendar_popover_title',
            'flags': '#flags_popup',
            'closeFlags': '.close_flags_popup',
            'openFlags': '.open_flags_popup'
        },

        events:{
            'mouseover @ui.menuTabs': 'hoverMenu',
            'mouseout @ui.menuTabs': 'hideMenu',
            'click @ui.closePopover': 'togglePopover',
            'click @ui.popover': 'togglePopover',
            'click @ui.closeFlags': 'toggleFlags',
            'click @ui.openFlags': 'toggleFlags'
        },

        initialize: function(){
            var that = this;

            this.bindUIElements();

            this.ui.popover.popover({
                content: function(){
                    return that.ui.popoverContent.html()
                },
                title: function(){
                    return that.ui.popoverTitle.html()
                }
            });

            var config = {
                rows: 10,
                columns: "date,time,country,event,volatility",
                selector: "#e_calendar_popover_content"
            };

            eCalendar(config);
        },

        toggleFlags: function(e){
            if(e) e.preventDefault();
            $('body').toggleClass('noscroll');
            this.ui.flags.toggle();
        },

        togglePopover: function(e){
            if(e) e.preventDefault();
            this.ui.popover.popover('toggle');
        },

        hoverMenu: function(e){
            $(e.currentTarget).find('.ct_msubmenuwrp').show();
        },

        hideMenu: function(e){
            $(e.currentTarget).find('.ct_msubmenuwrp').hide();
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/common/header_view.js
// module id = 19
// module chunks = 0